import { CountryCode } from 'libphonenumber-js/types';
import { useEffect } from 'react';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input';
import { HTMLCountrySelectElement } from 'src/components/ui/PhoneInput/PhoneInput';

export const useCountryPhoneSelect = (
  country: string,
  phoneSelect: HTMLCountrySelectElement | HTMLCountrySelectElement[]
) => {
  useEffect(() => {
    if (country && phoneSelect) {
      const phoneCountries = getCountries();
      if (phoneCountries?.some((c) => country === c)) {
        if (Array.isArray(phoneSelect)) {
          phoneSelect?.forEach((ps) => {
            ps.changeCode?.(getCountryCallingCode(country as CountryCode));
          });
        } else {
          phoneSelect.changeCode?.(
            getCountryCallingCode(country as CountryCode)
          );
        }
      }
    }
    // eslint-disable-next-line
  }, [country]);
};
